import React from "react";
import { useState } from "react";
import PaymentButton from "./PaymentButton";
import PaymentGatewayList from "./PaymentGatewayList";
import { useEffect } from "react";
const PaymentGateways = ({ checkoutResponse }) => {
  const [currentGateway, setCurrentGateway] = useState({});
  const [paymentGateways, setPaymentGateways] = useState([]);

  console.log("current", currentGateway);
  useEffect(() => {
    if (checkoutResponse) {
      const gatewayName =
        checkoutResponse?.order?.paymentGateway ||
        checkoutResponse?.settings?.paymentGateway;

      const environment =
        checkoutResponse?.order?.paymentGatewayEnvironment ||
        checkoutResponse?.settings?.paymentGatewayEnvironment;

      if (gatewayName) {
        setCurrentGateway({
          internal_name: gatewayName.toLowerCase(), // 🔥 IMPORTANT
          environment: environment,
        });
      }
    }
  }, [checkoutResponse]);
  return (
    <div>
      <PaymentGatewayList
        currentGateway={currentGateway}
        setCurrentGateway={setCurrentGateway}
        paymentGateways={paymentGateways}
        setPaymentGateways={setPaymentGateways}
      />

      <PaymentButton
        currentGateway={currentGateway}
        cartStorageKey={"hsCartProducts"}
        checkoutResponse={checkoutResponse}
        paymentGateways={paymentGateways}
      ></PaymentButton>
    </div>
  );
};

export default PaymentGateways;
